import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { faqQueries } from '@/services/faq/faq.queries';
import type { InquiryDetailsParams } from '@/services/faq/faq.types';

export const useInquiryDetails = ({ inquiryId }: InquiryDetailsParams) => {
  const { data, isLoading } = useQuery({
    ...faqQueries.inquiryDetails({ inquiryId: inquiryId }),
  });

  return {
    inquiryDetails: data?.data,
    loading: isLoading,
  };
};
